'use client';

import { NyttFärgTema } from 'src/theme/NyttFärgtema';

import type { KortProps } from '../kort-katalog';
import DomainCard from '../components/domain-card';

// ----------------------------------------------------------------------

export default function ÄrendenKort(_props: KortProps) {
    return (
        <DomainCard
            title="Aktuella ärenden"
            icon="solar:notebook-bold"
            theme={NyttFärgTema.Kombinationer[10]}
            emptyMessage="Här samlas pågående ärenden — underhåll, beslut och uppföljningar som styrelsen och föräldrarna arbetar med."
        />
    );
}
